import PushMobileApp from 'components/widgets/edito/PushMobileApp';
import { useCmsData } from 'utils/cms';

const AppStoreBadges = () => {
  const {
    generalSettings: { apps_title: appsTitle, apps_subtitle: appsSubtitle },
  } = useCmsData();

  return (
    <div className="flex flex-col gap-3 items-center text-center">
      <h3 className="title-3 text-neutral-900">{appsTitle}</h3>
      <PushMobileApp />
      <p className="text-lg text-neutral-800">{appsSubtitle}</p>
    </div>
  );
};

export default AppStoreBadges;
